import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const AgeCalculatorPage = () => {
  const [birthDate, setBirthDate] = useState('');
  const [ageAtDate, setAgeAtDate] = useState(new Date().toISOString().split('T')[0]);
  const [result, setResult] = useState(null);

  const calculateAge = () => {
    if (!birthDate) return;

    const birth = new Date(birthDate);
    const target = new Date(ageAtDate);

    if (birth > target) {
      alert('Birth date cannot be after the target date');
      return;
    }

    let years = target.getFullYear() - birth.getFullYear();
    let months = target.getMonth() - birth.getMonth();
    let days = target.getDate() - birth.getDate();

    if (days < 0) {
      months--;
      const lastMonth = new Date(target.getFullYear(), target.getMonth(), 0);
      days += lastMonth.getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    const diffTime = Math.abs(target - birth);
    const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const totalWeeks = Math.floor(totalDays / 7);
    const totalMonths = years * 12 + months;
    const totalHours = totalDays * 24;
    const totalMinutes = totalHours * 60;

    let nextBirthday = new Date(target.getFullYear(), birth.getMonth(), birth.getDate());
    if (nextBirthday <= target) {
      nextBirthday.setFullYear(nextBirthday.getFullYear() + 1);
    }
    const daysUntilBirthday = Math.ceil((nextBirthday - target) / (1000 * 60 * 60 * 24));

    setResult({
      years, months, days, totalDays, totalWeeks, totalMonths, totalHours, totalMinutes, daysUntilBirthday
    });
  };

  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />

      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 py-8">
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link>
            <span className="mx-2">›</span>
            <Link to="/other-calculators" className="text-cyan-400 hover:text-cyan-300">Other Calculators</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-400">Age Calculator</span>
          </nav>

          <h1 className="text-3xl font-bold text-white mb-2">Age Calculator</h1>
          <p className="text-gray-400 mb-8">
            Calculate your exact age including years, months, days, and even hours and minutes.
          </p>

          <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
            <div className="mb-5">
              <label className="block text-gray-300 mb-2 font-medium">Date of Birth</label>
              <Input
                type="date"
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
                className="w-52 bg-[#0d0d0d] border-[#2a2a2a] text-white [color-scheme:dark]"
              />
            </div>

            <div className="mb-5">
              <label className="block text-gray-300 mb-2 font-medium">Age at the Date of</label>
              <Input
                type="date"
                value={ageAtDate}
                onChange={(e) => setAgeAtDate(e.target.value)}
                className="w-52 bg-[#0d0d0d] border-[#2a2a2a] text-white [color-scheme:dark]"
              />
            </div>

            <Button onClick={calculateAge} className="bg-cyan-600 hover:bg-cyan-500 text-white">
              Calculate Age
            </Button>

            {result && (
              <div className="mt-6">
                <div className="p-5 bg-cyan-500/10 border border-cyan-500/30 rounded-xl mb-4">
                  <h3 className="text-lg font-semibold text-white mb-2">Your Age</h3>
                  <p className="text-3xl font-bold text-cyan-400">
                    {result.years} years, {result.months} months, {result.days} days
                  </p>
                </div>

                <div className="p-5 bg-[#0d0d0d] border border-[#2a2a2a] rounded-xl">
                  <h3 className="text-lg font-semibold text-white mb-4">Age in Different Units</h3>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="p-3 bg-[#1a1a1a] rounded-lg">
                      <span className="text-gray-500 text-sm">Total Months</span>
                      <p className="font-semibold text-white">{result.totalMonths.toLocaleString()}</p>
                    </div>
                    <div className="p-3 bg-[#1a1a1a] rounded-lg">
                      <span className="text-gray-500 text-sm">Total Weeks</span>
                      <p className="font-semibold text-white">{result.totalWeeks.toLocaleString()}</p>
                    </div>
                    <div className="p-3 bg-[#1a1a1a] rounded-lg">
                      <span className="text-gray-500 text-sm">Total Days</span>
                      <p className="font-semibold text-white">{result.totalDays.toLocaleString()}</p>
                    </div>
                    <div className="p-3 bg-[#1a1a1a] rounded-lg">
                      <span className="text-gray-500 text-sm">Total Hours</span>
                      <p className="font-semibold text-white">{result.totalHours.toLocaleString()}</p>
                    </div>
                    <div className="p-3 bg-[#1a1a1a] rounded-lg col-span-2">
                      <span className="text-gray-500 text-sm">Total Minutes</span>
                      <p className="font-semibold text-white">{result.totalMinutes.toLocaleString()}</p>
                    </div>
                  </div>
                </div>

                <div className="mt-4 p-4 bg-orange-500/10 border border-orange-500/30 rounded-xl text-center">
                  <p className="text-orange-400 font-medium">
                    {result.daysUntilBirthday} days until your next birthday!
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default AgeCalculatorPage;
